'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var nlLabels = exports.nlLabels = {
  nextMonth: 'Volgende maand',
  previousMonth: 'Vorige maand'
};

exports.default = {
  nl: nlLabels
};